import { useState, useEffect } from "react";
import { TenantConfig, getCurrentConfig } from "../tenant-config";

export function useConfig(): TenantConfig {
  const [config, setConfig] = useState<TenantConfig>(getCurrentConfig());

  useEffect(() => {
    // Reload config khi component mount
    setConfig(getCurrentConfig());
  }, []);

  return config;
}

export function useConfigValue<T extends keyof TenantConfig>(
  key: T
): TenantConfig[T] {
  const config = useConfig();
  return config[key];
}
